<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item v-if='redefineBoolean' prefixIcon='icon hero-icon hero-icon-redefine' :tooltipText='$t("Alarm.redefine")' :click='notices' eventType='redefine'></e-item>
        <e-item v-if='broadbandInquiryBoolean' prefixIcon='icon hero-icon hero-icon-lte-search' :tooltipText='$t("Alarm.broadbandInquiry")' :click='notices' eventType='queryLTE'></e-item>
        <e-item v-if='editBoolean' prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Alarm.edit")' :click='notices' eventType='edit'></e-item>
        <e-item v-if='restorationBoolean' prefixIcon='icon hero-icon hero-icon-previous-layer' :tooltipText='$t("Alarm.restoration")' :click='notices' eventType='reset'></e-item>
      </e-items>
    </ejs-toolbar>
    <div class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("Alarm.pleaseEnterAlarmDescription")' @input='updateKeywords' @keydown.native='keydownFunc'></ejs-textbox>
    </div>
  </div>
</template>
<script>

export default {
  name: 'alarmRedirectTableButton',
  data() {
    return {
      redefineBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_redirect.Redefined,
      broadbandInquiryBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_redirect.QueryAlarm,
      editBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_redirect.Modify,
      restorationBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_redirect.Reset,
      queryConditions: {
        keywords: ''
      }
    };
  },
  methods: {
    notices(args) {
      this.$emit('notice', args.item.eventType);
    },
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
    },
    keydownFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        if (this.queryConditions.keywords === '') {
          this.queryConditions.keywords = '';
        }
        this.$emit('notice', 'refresh');
      }
    }
  }
};
</script>
